import React from 'react';
import { useSelector } from 'react-redux';
import history from '../../../history';
import { redirectToUrl } from '../../../utils/navigation';

//COMPONENTS
import CartIcon from './cartIcon';
import UserIcon from './userIcon';

import './header.css'

//IMAGES
import CotalityLogo from '../../../image/CotalityLogo-header.svg';
import HeaderLine from '../../../image/header-line.svg';

export default function Header(props) {
  const product = useSelector((state) => state.packageSelection);
  const cart = useSelector((state) => state.cart);
  const order = useSelector((state) => state.order);

  function redirectToURL(link) {
    props.SegmentAnalytics.trackReturnToCorelogic(product);
    if (process.env.NODE_ENV !== 'test') {
      redirectToUrl(link);
    }
  }

  /* istanbul ignore next */
  const goToCart = () => {
    props.SegmentAnalytics.trackGotoCart(props.ProductItemsService.getCartItemsCount(cart.cart, order));
    history.push('/cart');
  };

  return (
    <header>
      <nav className="navbar" id='navbar-header'>
        <div className="container-fluid">
          <a id='navbar-brand' className="navbar-brand" onClick={() => redirectToURL("https://www.cotality.com/au")}>
            <img
              alt='Brand'
              id='cotality-logo'
              className='logo-brand'
              src={CotalityLogo}
            />
          </a>
          <div className="pull-right">
            <CartIcon {...props} goToCart={goToCart} />
            <a id="view-cart-link" onClick={goToCart}>
              View Cart
            </a>
            <a>
              <img
                alt='|'
                id='header-line'
                src={HeaderLine}
              />
            </a>
            <UserIcon analyticsLogoutUser={props.SegmentAnalytics.analyticsLogoutUser} />
          </div>
        </div>
      </nav>
    </header>
  );
}
